import { render, staticRenderFns } from "./PosDocumentDetail.vue?vue&type=template&id=5efa3220&"
import script from "./PosDocumentDetail.vue?vue&type=script&lang=js&"
export * from "./PosDocumentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports